import { ItemEntity } from '@generated/gql';
import { SECONDS_IN_DAY, timestampNowInSeconds } from '@shared/time-utils';

export function isExpiredItem(item: ItemEntity): boolean {
  const currentTimestamp = timestampNowInSeconds();
  return +(item.timestamp || 0) + SECONDS_IN_DAY < currentTimestamp;
}
